import type { ReactNode } from "react";

export { OverflowReveal, type OverflowRevealProps } from "./OverflowRevealView.js";
export {
  DEFAULT_OVERFLOW_PREVIEW_CHARACTERS,
  overflowCharacterCount,
  overflowPopoverPosition,
  overflowPreview,
  type OverflowRevealKind
} from "./overflowReveal.js";

export function StatusPill({
  tone = "neutral",
  children
}: {
  tone?: "live" | "warning" | "danger" | "neutral" | "accent";
  children: ReactNode;
}) {
  return <span className={`status-pill status-pill--${tone}`}>{children}</span>;
}

export function Panel({
  title,
  eyebrow,
  action,
  className = "",
  children
}: {
  title: string;
  eyebrow?: string;
  action?: ReactNode;
  className?: string;
  children: ReactNode;
}) {
  return (
    <section className={`panel ${className}`}>
      <header className="panel__header">
        <div>
          {eyebrow ? <div className="panel__eyebrow">{eyebrow}</div> : null}
          <h2>{title}</h2>
        </div>
        {action}
      </header>
      <div className="panel__body">{children}</div>
    </section>
  );
}

export function EmptyState({ title, detail }: { title: string; detail: string }) {
  return (
    <div className="empty-state">
      <div className="empty-state__orb" aria-hidden="true" />
      <strong>{title}</strong>
      <span>{detail}</span>
    </div>
  );
}
